import { Component, OnInit } from "@angular/core";
import { GeneralService } from "src/app/services/general.service";
import { CommunicationCommand } from "src/app/models/communicationCommands";
import * as localForage from "localforage";
// import { RegistrationResponse } from 'src/app/models/auth';

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"]
})
export class DashboardComponent implements OnInit {
  showProfileIncompleteMessage: boolean = false;
  constructor(private generalservice: GeneralService) {}

  ngOnInit(): void {
    this.getProfileData();
  }

  openSettings() {
    let openSettings: CommunicationCommand = new CommunicationCommand(
      "open",
      "",
      "settings"
    );

    this.generalservice.switchSidebarOnOrOff(openSettings);
  }

  async getProfileData() {
    try {
      const res = await localForage.getItem("completionStatus");
      if (res["score"] < 100) {
        this.showProfileIncompleteMessage = true;
      } else {
        this.showProfileIncompleteMessage = false;
      }
    } catch (error) {
      console.log(error);
      this.showProfileIncompleteMessage = false;
    }
  }
}
